import addIc from '@/assets/icons/add.svg';
import done3Ic from '@/assets/icons/done3.svg';
import styles from './SuccessScreen.module.css';

interface SuccessScreenProps {
  iconSrc?: string;
  title: string;
  description?: string;
  additionalText?: string;
  primaryButtonText?: string;
  primaryButtonAction?: () => void;
  secondaryButtonText?: string;
  secondaryButtonAction?: () => void;
  /** The plus says "add another"; a secondary that means something else ("finish") turns it off. */
  showSecondaryIcon?: boolean;
  /** More plain actions under the secondary button (HAT-1453: continue to a request, add classifications). */
  extraButtons?: { text: string; action: () => void }[];
}

const SuccessScreen = ({
  iconSrc,
  title,
  description,
  additionalText,
  primaryButtonText,
  primaryButtonAction,
  secondaryButtonText,
  secondaryButtonAction,
  showSecondaryIcon = true,
  extraButtons = [],
}: SuccessScreenProps) => {
  return (
    <div className={styles.container}>
      {/* Success Icon and Message */}
      <div className={styles.successSection}>
        <div className={styles.iconContainer}>
          <div className={styles.iconOuterBorder}></div>
          <div className={styles.iconBackground}>
            <img src={iconSrc || done3Ic} alt="Success" className={styles.icon} />
          </div>
        </div>

        <div className={styles.textContent}>
          <h1 className={`heading-h1-bold ${styles.title}`}>
            {title}
          </h1>
          <p className={`body-lr-regular ${styles.description}`}>
            {description}
          </p>
          {additionalText && (
            <p className={`body-lr-semibold ${styles.additionalText}`}>
              {additionalText}
            </p>
          )}
        </div>
      </div>

      {/* Action Buttons */}
      <div className={styles.buttonsContainer}>
        {/* Primary Button */}
        {primaryButtonText && (
          <button
            onClick={primaryButtonAction}
            className={styles.primaryButton}
          >
            <div className={styles.primaryButtonContent}>
              <p className={`body-lr-semibold ${styles.primaryButtonText}`}>
                {primaryButtonText}
              </p>
            </div>
          </button>
        )}

        {/* Secondary Button */}
        {secondaryButtonText && (
          <button
            onClick={secondaryButtonAction}
            className={styles.secondaryButton}
          >
            <div className={styles.secondaryButtonContent}>
              {showSecondaryIcon && (
                <div className={styles.iconWrapper}>
                  <img src={addIc} alt="Add" className={styles.buttonIcon} />
                </div>
              )}
              <p className={`body-lr-semibold ${styles.secondaryButtonText}`}>
                {secondaryButtonText}
              </p>
            </div>
          </button>
        )}
        {extraButtons.map((b) => (
          <button key={b.text} onClick={b.action} className={styles.secondaryButton}>
            <div className={styles.secondaryButtonContent}>
              <p className={`body-lr-semibold ${styles.secondaryButtonText}`}>{b.text}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuccessScreen;

